import Product from '@/products/entities/product'

export default class Profiles {
    public front: Product | null = null
    public back: Product | null = null
    public left: Product | null = null
    public right: Product | null = null
    public special: Product | null = null
}
